import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../data/mock";

const ServicesGrid = ({ limit }) => {
  const list = limit ? SERVICES.slice(0, limit) : SERVICES;
  return (
    <section className="section-pad bg-white">
      <div className="lis-container">
        <div className="max-w-2xl">
          <span className="eyebrow">Center of Excellence</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">ISO consulting for every management system</h2>
          <div className="divider-red mt-4" />
          <p className="mt-4 text-slate-600">
            We cover the complete lifecycle for every major ISO standard   awareness, gap analysis, documentation, implementation, internal audits, and certification support.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((s) => {
            const Icon = Icons[s.icon] || Icons.BadgeCheck;
            return (
              <div key={s.slug} className="service-card card-hover">
                <span className="accent" />
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ background: `${s.color}15`, color: s.color }}>
                    <Icon size={22} />
                  </div>
                  <span className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">{s.tag}</span>
                </div>
                <div className="mt-4 text-sm font-bold text-brand">{s.code}</div>
                <h3 className="mt-1 text-lg font-semibold text-slate-900 leading-snug">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.excerpt}</p>
                <Link to={`/services/${s.slug}`} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand hover:gap-3 transition-all">
                  Learn more <ArrowRight size={14} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
